export { default as Tabs } from './Tabs'
export { TabHeaderProps } from './components/TabHeader'
